import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    colores: [],
  },

  getters: {
    getColores: (state) => state.colores,
  },

  mutations: {
    SET_COLORES(state, colores) {
      state.colores = colores;
    },
  },

  actions: {
    async fetchColores({ commit }) {
      await axios
        .get('/EonCloud/colores')
        .then((response) => {
          commit('SET_COLORES', response.data.data);
        });
    },
  },
};
